export default {
    async reset({ commit }) {
        commit('reset')
    },

    async set({ state, commit }, payload) {
        let result = { ok: false }
        try {
            commit('set', payload)
            result = { ok: true }
        }
        catch (e) {
            console.log(e)
        }
        return result
    }
}
